import { motion } from "framer-motion";
import { useCardsStore } from "@/zustand/store";
import { useDeleteCardAdmin } from "@/hooks/use-mutations";
import { useFreezeCards, useUnfreezeCards } from "@/hooks/use-mutations";

import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import Throbber from "@/components/throbber";
import { Snowflake, Trash2 } from "lucide-react";

const FreezeCard = ({
  cardData,
  closeModal,
}: {
  cardData: Card;
  closeModal: () => void;
}) => {
  const { id: cardId, status: cardStatus } = cardData;
  const queryClient = useQueryClient();

  const { mutateAsync: freezeCard, isPending: isFreezing } = useFreezeCards({
    id: cardId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cardInfo"] });
      closeModal();
    },
  });
  const { mutateAsync: unfreezeCard, isPending: isUnfreezing } =
    useUnfreezeCards({
      id: cardId,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["cardInfo"] });
        closeModal();
      },
    });

  return (
    <div className="mx-auto flex flex-col items-center text-center">
      <div className="text-primary-500 border-primary-100 flex size-16 items-center justify-center rounded-full border bg-white">
        <Snowflake className="size-6" strokeWidth={1.5} />
      </div>
      <p className="mt-4 text-2xl font-medium text-white">
        {cardStatus === "Frozen" ? "Unfreeze" : "Freeze"} Card
      </p>
      <p className="text-sm text-white">
        Are you sure you want to{" "}
        {cardStatus === "Frozen" ? "UNFREEZE" : "FREEZE"} this card?
      </p>

      <div className="mt-6 flex w-full gap-2">
        <Button
          variant={"outline"}
          onClick={() => closeModal()}
          className="border-primary-100 text-primary-100 grow rounded-md border bg-transparent"
        >
          Close
        </Button>
        <Button
          onClick={() => {
            if (cardStatus === "Frozen") {
              unfreezeCard();
            } else {
              freezeCard();
            }
          }}
          className="text-primary-500 grow rounded-md bg-white hover:bg-neutral-100"
        >
          {isFreezing || isUnfreezing ? (
            <Throbber />
          ) : cardStatus === "Frozen" ? (
            " Unfreeze"
          ) : (
            "Freeze"
          )}
        </Button>
      </div>
    </div>
  );
};

export default FreezeCard;
